module.exports = __webpack_public_path__ + "static/media/voting-logo.54a8aba4.png";